import { render, staticRenderFns } from "./TabDropdown.vue?vue&type=template&id=452cf0b5&"
import script from "./TabDropdown.vue?vue&type=script&lang=js&"
export * from "./TabDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports